import useAIFeedbackStore from "@features/session/hooks/useAIFeedbackStore";
import type {
	WorkflowItemEdge,
	WorkflowItemNode,
} from "@memorang/types/src/session/new-session";
import CustomTabs from "components/CustomTabs";
import { WorkflowGraph } from "./WorkflowGraph";

type Props = {
	id: number | undefined;
	initialNodes: WorkflowItemNode[];
	initialEdges: WorkflowItemEdge[];
	correctNodes: WorkflowItemNode[];
	correctEdges: WorkflowItemEdge[];
	isAnswered?: boolean;
};

export const WorkflowItem = ({
	id,
	initialNodes,
	initialEdges,
	correctNodes,
	correctEdges,
	isAnswered,
}: Props) => {
	const setUserResponse = useAIFeedbackStore((state) => state.setUserResponse);

	const handleUpdateResponse = (workflowReport: string) => {
		setUserResponse(id!, workflowReport);
	};

	const commonProps = {
		initialNodes,
		initialEdges,
		correctNodes,
		correctEdges,
		handleUpdateResponse,
		disabled: isAnswered,
	};

	const tabs = [
		{
			label: "Workflow",
			content: <WorkflowGraph {...commonProps} mode="user" />,
			icon: "sitemap-outline",
		},
	];

	if (isAnswered) {
		tabs.push({
			label: "Correct",
			content: <WorkflowGraph {...commonProps} mode="correct" />,
			icon: "check",
		});
	}

	return <CustomTabs tabs={tabs} />;
};
